import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from './components/login';
import Dashboard from './components/dashboard';
import Research from "./components/Research";
import VolunteersBoard from "./components/volunteers";
import FutureVolunteers from "./components/FutureVolunteers";
import USAID from "./components/USAID";

function App() {
    return (
        <Router>
            <Routes>
                {/* Authentication Routes */}
                <Route path="/" element={<Login />} />

                {/* Main Dashboard */}
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/research" element={<Research />} />
                <Route path="/volunteers" element={<VolunteersBoard />} />
                <Route path="/futurevolunteers" element={<FutureVolunteers />} />
                <Route path="/USAID" element={<USAID />} />
            </Routes>
        </Router>
    );
}

export default App;
